import { APP_INITIALIZER } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { keycloakConfig } from '../config/keycloak.config';

export function initializeKeycloak(keycloak: KeycloakService) {
  return () =>
    keycloak.init({
      config: keycloakConfig,
      initOptions: {
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri:
          window.location.origin + '/assets/silent-check-sso.html',
        checkLoginIframe: false,
        checkLoginIframeInterval: 5,
        scope: 'openid profile email'
      },
      enableBearerInterceptor: false,
      shouldAddToken: () => false,
      bearerExcludedUrls: ['/assets/', '/api/public/']
    }).then(() => {
      // Benutzerprofil laden, wenn angemeldet
      if (keycloak.isLoggedIn()) {
        console.log('[Keycloak] User is logged in, loading profile...');
        
        // Token inspizieren für Debugging
        try {
          const keycloakInstance = keycloak.getKeycloakInstance();
          if (keycloakInstance?.token) {
            const tokenParts = keycloakInstance.token.split('.');
            if (tokenParts.length === 3) {
              const decoded = JSON.parse(atob(tokenParts[1]));
              console.log('[Keycloak] Token Audience:', decoded.aud);
              console.log('[Keycloak] Token Issuer:', decoded.iss);
              console.log('[Keycloak] Token Subject:', decoded.sub);
              console.log('[Keycloak] Token Expires:', new Date(decoded.exp * 1000).toISOString());
            }
          }
        } catch (error) {
          console.error('[Keycloak] Failed to inspect token:', error);
        }
        
        return keycloak.loadUserProfile().then(() => {
          console.log('[Keycloak] User profile loaded successfully');
          return Promise.resolve();
        }).catch(err => {
          console.error('[Keycloak] Failed to load user profile:', err);
          // Trotzdem weitermachen, aber mit degradierter Funktionalität
          return Promise.resolve();
        });
      }
      return Promise.resolve();
    }).catch(err => {
      console.warn('[Keycloak] Keycloak initialization failed - continuing without authentication:', err);
      // App funktioniert trotzdem, nur Admin-Login ist nicht verfügbar
      return Promise.resolve();
    });
}

export const keycloakInitializer = {
  provide: APP_INITIALIZER,
  useFactory: initializeKeycloak,
  multi: true,
  deps: [KeycloakService]
};
